<script>
  import { onMount } from 'svelte';
  import { fly } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  import Button, { options as buttonsOptions } from '@ctm/ui/Button';
  import helpIcon from './helpIcon.svg';
  import closeIcon from './closeIcon.svg';
  import chevronIcon from './chevronIcon.svg';
  import bookingImage from './bookingImage.png';
  import EditCCandDept from './EditCCandDept.gif';
  import flightImage from './flightImage.png';
  import flightDetails from './flightDetails.gif';
  import flightPreferred from './flightPreferred.png';
  import flightOnTime from './flightOnTime.png';
  import flightFastest from './flightFastest.png';
  import hotelImage from './hotelImage.png';
  import hotelNonRefundable from './hotelNonRefundable.png';
  import hotelPreferred from './hotelPreferred.png';
  import hotelRecommended from './hotelRecommended.png';
  import carImage from './carImage.png';

  import {
    helpPanelOpen,
    helpPanelContentKey
  } from '../../store/index.js';

  const content = {
    'homeSearch': {
      image: bookingImage,
      appCues: () => {
        Appcues.clearShow();
        Appcues.show('-Lb5IYh3g6uSv32r80HW');
      },
      header: 'Making a booking',
      content: `Need a hand getting started? Take a quick interactive tour of how to start your booking.`,
      tips: [
        {
          image: EditCCandDept,
          header: 'Cost centre and departments',
          content: `If your company requires it, you can click on the modify/pen icon next to a travellers name to select or change their cost centre and department.`,
        }
      ]
    },
    'flightResults': {
      image: flightImage,
      appCues: () => {
        Appcues.clearShow();
        Appcues.show('-LbPnHj_mVOx1dLfjjoS');
      },
      header: 'Flight Results',
      content: `Need help finding the best flight for your needs? Let us show you how.`,
      tips: [
        {
          image: flightDetails,
          header: 'Comfort and Amenities',
          content: `Need wifi? or maybe just want to see how much legroom your seat has? expand a flight to see a breakdown of each flights amenities and comfort helping you make more informed choices when shopping for a flight.`,
        },
        {
          image: flightPreferred,
          header: 'Preferred',
          content: `An airline that has been endorsed by your company, giving you access to a better rate.`,
        },
        {
          image: flightOnTime,
          header: 'On Time',
          content: `The percentage this flight departs on time.`,
        },
        {
          image: flightFastest,
          header: 'Fastest Trip',
          content: `The shortest flight duration for this trip. There can be more than one fastest trip if more that one flight has the same duration.`,
        }
      ]
    },
    'hotelResults': {
      image: hotelImage,
      appCues: () => {
        Appcues.clearShow();
        Appcues.show('-LbQJ4WamkKkKAXWvocQ');
      },
      header: 'Hotel Results',
      content: `Need help finding the best hotel for your needs? Let us show you how.`,
      tips: [
        {
          image: hotelNonRefundable,
          header: 'Non refundable content',
          content: `Any hotels that charge you instantly at purchase or has a no refund policy for bookings are marked clearly to assist with your selection.`,
        },
        {
          image: hotelPreferred,
          header: 'Preferred Hotel',
          content: `A hotel that has been endorsed by your company, giving you access to a better rate.`,
        },
        {
          image: hotelRecommended,
          header: 'Recommended',
          content: `A hotel that has been endorsed by us, giving you access to a better rate.`,
        }
      ]
    },
    'carResults': {
      image: carImage,
      appCues: () => {
        Appcues.clearShow();
        Appcues.show('-LbQk870tjqQ9B1YEQ5d');
      },
      header: 'Car Results',
      content: `Need help finding the best car for your needs? Let us show you how.`,
      tips: []
    }
  }

  let activeTipIndex = 0;
  let AppCuesEnabled = true;

  onMount(() => {
    AppCuesEnabled = window.AppCuesEnabled
  });

  function handleTour() {
    activeContent.appCues();
    $helpPanelOpen = false;
  }

  function handleChevron(args) {
    if (args.increase && activeContent.tips.length > activeTipIndex + 1) {
      activeTipIndex += 1;
    }

    if (!args.increase && activeTipIndex > 0) {
      activeTipIndex -= 1;
    }

    activeTipIndex = activeTipIndex;
  }

  export let activeContent;
  $: {
    if (!$helpPanelContentKey && content[$helpPanelContentKey]) {
      activeContent = false;
    } else {
      activeContent = content[$helpPanelContentKey];
    }
  }

  export let activeTip;
  $: {
    if (!activeContent || activeContent.tips.length < 1) {
      activeTip = false
    } else {
      activeTip = activeContent.tips[activeTipIndex]
    }
  }
</script>

<style>
  :global(body) {
    overflow-x: hidden
  }

  .panel {
    position: fixed;
    right: 0;
    min-height: 100%;
    width: 382px;
    background: #18222C;
    top: 0;
    bottom: 0;
    color: #fff;
    padding: 41px 32px 0 32px;
    z-index: 99999999;
    overflow-y: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }

  .panel::-webkit-scrollbar {
    display: none;
  }


  .title {
    font-size: 21px;
    letter-spacing: 0.33px;
    line-height: 26px;
    margin: 0 0 52px;
  }

  .close {
    position: absolute;
    top: 51px;
    right: 32px;
    width: 12px;
    height: 12px;
  }

  .close:hover {
    cursor: pointer;
  }

  .tourContent {
    margin-bottom: 64px;
  }

  .tourContent img {
    height: 164px;
    width: 319px;
    border-radius: 4px;
    margin-bottom: 16px;
    display: block;
  }

  .tourContent h2 {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.24px;
    line-height: 18px;
    margin-bottom: 8px;
  }

  .tourContent p {
    font-size: 14px;
    letter-spacing: -0.15px;
    line-height: 20px;
  }

  .featureTips {
    position: relative;

  }

  .featureTips h2 {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.24px;
    line-height: 18px;
  }

  .nav {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
  }

  .navLeft {
    margin-right: 10px;
    width: 8px;
    height: 16px;
  }

  .nav span {
    margin-right: 10px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: -0.08px;
    width: 25px;
    text-align: center
  }

  .navRight {
    transform: rotate(180deg);
    width: 8px;
    height: 16px;
  }

  .navLeft:hover,
  .navRight:hover {
    cursor: pointer;
  }

  .featureTips h3 {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.24px;
    line-height: 18px;
  }

  .featureTips p {
    font-size: 14px;
    letter-spacing: -0.15px;
    line-height: 20px;
  }
</style>


{#if $helpPanelOpen}
<div class="panel" transition:fly="{{x:382, duration: 300, easing: quintOut}}">
    <img src="{ closeIcon }" alt="close" class="close" on:click="{() => $helpPanelOpen = false }">
    <h1 class="title">Help Centre</h1>

    {#if activeContent}
        {#if AppCuesEnabled}
        <div class="tourContent">
            <img src="{activeContent.image}" alt="tour image">
            <h2>{activeContent.header}</h2>
            <p>{activeContent.content}</p>
            <Button on:click="{handleTour}" size="{buttonsOptions.size.MEDIUM}" type="{buttonsOptions.type.PRIMARY}">Take
                the tour</Button>
        </div>
        {/if}

        {#if activeTip}

        <div class="featureTips">
            <h2>Featured tips</h2>

            <div class="nav">
                <img src="{chevronIcon}" alt="chevron" class="navLeft" on:click="{() => handleChevron({increase:false})}">
                <span>{activeTipIndex + 1}/{activeContent.tips.length}</span>
                <img src="{chevronIcon}" alt="chevron" class="navRight" on:click="{() => handleChevron({increase:true})}">
            </div>

            <img src="{activeTip.image}" alt="tip image">
            <h3>{activeTip.header}</h3>
            <p>{activeTip.content}</p>
        </div>

        {/if}
    {/if}
</div>
{/if}
